"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartRangeType = void 0;
var ChartRangeType;
(function (ChartRangeType) {
    ChartRangeType[ChartRangeType["ONE"] = 1] = "ONE";
    ChartRangeType[ChartRangeType["THREE"] = 3] = "THREE";
    ChartRangeType[ChartRangeType["FIVE"] = 5] = "FIVE";
    ChartRangeType[ChartRangeType["TEN"] = 10] = "TEN";
    ChartRangeType[ChartRangeType["ALL"] = 99] = "ALL";
    ChartRangeType[ChartRangeType["CUSTOM"] = -1] = "CUSTOM";
})(ChartRangeType = exports.ChartRangeType || (exports.ChartRangeType = {}));
